export default __webpack_public_path__ + "static/media/3.8e33d6a6.jpg";